import { useEffect, useRef } from 'react';
import { IGraphProps } from '../types';

type UseDimensions = {
  height: IGraphProps['height'];
  width: IGraphProps['width'];
};

export const useDimensions = ({ height, width }: UseDimensions) => {
  const dimensionsRef = useRef({ height, width });

  useEffect(() => {
    dimensionsRef.current = { height, width };
  }, [height, width]);

  return dimensionsRef;
};
